import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import login from './views/Login.vue';
import axios from 'axios'; //引入axios
import store from '@/store/store.js';
import './utils/dialog-directive';
import echarts from 'echarts';
Vue.prototype.$store = store;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.hostid = "http://172.16.101.91:8080/";
Vue.prototype.apiurl = "https:///sznj-api.web.jet.work/api/";
//Vue.prototype.apiurl = "https://172.16.101.17:7220/api/";
//Vue.prototype.apiurl = "http://118.112.180.234:5000/api/";
//Vue.prototype.apiurl = "http://115.159.46.60:5000/api/";
Vue.prototype.$echarts = echarts;
Vue.prototype.waiwangid = "https://sznj.web.jet.work/#/";
new Vue({
  store,
  router,
  //ElementUI,
  render: h => h(App)
}).$mount('#app')
// 添加点击事件监听，实现蒙版效果和记录功能

